module.exports = __webpack_public_path__ + "static/media/fly0262.bac27899.webp";